import { useEffect } from 'react';
import { tourService, TourPhase } from '../services/tourService';

export interface SimpleTourStep {
  element: string;
  title: string;
  description: string;
}

export const useSimpleTour = (phase: TourPhase, steps: SimpleTourStep[]) => {
  useEffect(() => {
    const handleTour = () => {
      if (tourService.isActive() && tourService.getPhase() === phase) {
        const mappedSteps = steps.map((s) => ({
          element: s.element,
          popover: {
            title: s.title,
            description: s.description,
            showButtons: ['next'] as any
          }
        }));

        if (mappedSteps.length > 0) {
          tourService.createDriver(mappedSteps);
        }
      }
    };

    const timeoutId = setTimeout(handleTour, 800);
    window.addEventListener('libritui-tour-started', handleTour);
    
    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener('libritui-tour-started', handleTour);
    };
  }, [phase, steps]);
};
